import React from 'react';
import {
  Box,
  Container,
  Typography,
  Button,
  Stack,
  Avatar,
  Paper,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import {
  AutoStories as AutoStoriesIcon,
  ArrowBack as ArrowBackIcon,
  Apple as AppleIcon,
  Android as AndroidIcon,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const APP_STORE_URL = 'https://apps.apple.com/app/tadubbur-ai';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.naeemanaeem.tadubburcompanion';

function TadabburIntro() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();

  const handleBackToLanding = () => {
    navigate('/landing');
  };

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#fafafa' }}>
      <Box
        sx={{
          position: 'sticky',
          top: 0,
          zIndex: 10,
          bgcolor: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(10px)',
          borderBottom: '1px solid rgba(0,0,0,0.08)',
        }}
      >
        <Container maxWidth="md">
          <Button
            startIcon={<ArrowBackIcon />}
            onClick={handleBackToLanding}
            sx={{ py: 2, color: '#1976d2', fontWeight: 600 }}
          >
            Back to Baiglabs
          </Button>
        </Container>
      </Box>

      <Container maxWidth="md" sx={{ py: 6 }}>
        <Paper elevation={0} sx={{ p: { xs: 3, md: 6 }, borderRadius: 3, border: '1px solid', borderColor: 'divider' }}>
          <Box sx={{ textAlign: 'center', mb: 4 }}>
            <Avatar
              sx={{
                width: 80,
                height: 80,
                bgcolor: '#0d4f4f',
                mx: 'auto',
                mb: 2,
              }}
            >
              <AutoStoriesIcon sx={{ fontSize: 40 }} />
            </Avatar>
            <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 700, color: '#0d4f4f' }}>
              Tadabbur
            </Typography>
            <Typography variant="h6" color="text.secondary" sx={{ maxWidth: '560px', mx: 'auto' }}>
              Reflective Quran study with grounded answers, tafsir, and Arabic learning on the go.
            </Typography>
          </Box>

          <Typography variant="body1" paragraph sx={{ textAlign: 'center', maxWidth: '560px', mx: 'auto' }}>
            Tadabbur (Tadubbur AI Companion) helps you ask questions about the Quran, explore classical
            commentary, and build Quranic Arabic skills through guided lessons—backed by a BaigLabs API
            that keeps study grounded in the text.
          </Typography>

          <Box sx={{ textAlign: 'center', mt: 5, mb: 4 }}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
              Download Tadabbur
            </Typography>
            <Stack
              direction={isMobile ? 'column' : 'row'}
              spacing={2}
              justifyContent="center"
              alignItems="center"
              flexWrap="wrap"
            >
              <Button
                href={APP_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                variant="contained"
                size="large"
                startIcon={<AppleIcon />}
                sx={{
                  bgcolor: '#000',
                  px: 3,
                  py: 1.5,
                  '&:hover': { bgcolor: '#333' },
                }}
              >
                App Store
              </Button>
              <Button
                href={PLAY_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                variant="contained"
                size="large"
                startIcon={<AndroidIcon />}
                sx={{
                  bgcolor: '#0d4f4f',
                  px: 3,
                  py: 1.5,
                  '&:hover': { bgcolor: '#083838' },
                }}
              >
                Google Play
              </Button>
            </Stack>
          </Box>

          <Box sx={{ textAlign: 'center', mt: 4 }}>
            <Button
              component="a"
              href="/quran/privacy"
              target="_blank"
              rel="noopener noreferrer"
              variant="text"
              sx={{ color: 'text.secondary', mr: 1 }}
            >
              Privacy Policy
            </Button>
            <Button
              component="a"
              href="/quran/terms"
              target="_blank"
              rel="noopener noreferrer"
              variant="text"
              sx={{ color: 'text.secondary', mr: 1 }}
            >
              Terms of Service
            </Button>
            <Button
              startIcon={<ArrowBackIcon />}
              onClick={handleBackToLanding}
              variant="text"
              sx={{ color: 'text.secondary' }}
            >
              Back to landing page
            </Button>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
}

export default TadabburIntro;
